// extracted by mini-css-extract-plugin
export default {"tabsContainer":"Tabs-module__tabsContainer--Q6jAl","tabsItem":"Tabs-module__tabsItem--4L2bN"};